module.exports = __webpack_public_path__ + "img/sand-rock-big-13.15411376.png";